import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  input,
  output,
} from '@angular/core';
import { Params } from '@angular/router';
import { WorkplaceService } from '@qaroni-app/workplace/services/workplace.service';

@Component({
  selector: 'qaroni-workplace-filter',
  templateUrl: './workplace-filter.component.html',
  styleUrl: './workplace-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplaceFilterComponent implements OnInit {
  readonly companyID = input<number>(0);
  readonly multiple = input<boolean>(false);
  readonly workplaceFilterLabel = input<string>($localize`Centro de Trabajo`);
  readonly queryParamName = input<string>('workplaceId');

  readonly queryParamsChange = output<Params>();

  private workplaceService = inject(WorkplaceService);
  public workplaces$ = this.workplaceService.list$();

  ngOnInit(): void {
    const params = {
      page: 1,
      pagination: 1000,
    };

    this.workplaceService.list(this.companyID(), params);
  }

  public onQueryParamsChange(params: Params): void {
    this.queryParamsChange.emit(params);
  }
}
